import { render, staticRenderFns } from "./SafeDigResetPassword.vue?vue&type=template&id=2904d907&scoped=true"
import script from "./SafeDigResetPassword.vue?vue&type=script&lang=js"
export * from "./SafeDigResetPassword.vue?vue&type=script&lang=js"
import style0 from "./SafeDigResetPassword.vue?vue&type=style&index=0&id=2904d907&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2904d907",
  null
  
)

export default component.exports